<template>
  <div class="admin__home">
    <Header />
    <div class="admin__home--left-div">
      <Sidebar :item="item" />
    </div>
    <div class="admin__home--right-div">
      <div class="edit">
        <p>
          <span class="edit__back">
            <routerLink to="/settings">User Management</routerLink>
          </span>
          &raquo;
          <span class="edit__current">Edit Admin Permissions</span>
        </p>

        <div class="edit__container">
          <div class="edit__container--avatar">
            <img src="./../../../assets/images/user.svg" alt="avatar" />
          </div>
          <div class="edit__container--text">Edit Admin Permissions</div>
          <div class="edit__container--loader" v-show="pageLoading">
            <div>
              <PageLoader />
            </div>
          </div>
          <div class="edit__container--details" v-show="!pageLoading">
            <div class="edit__container--details-header">
              <div class="edit__container--details-header-left">
                Admin Name:
              </div>
              <div class="edit__container--details-header-middle">
                <span>{{ userName }}</span>
                <p>
                  <routerLink :to="'/employee/' + userID"
                    >- view profile</routerLink
                  >
                </p>
              </div>
              <div class="edit__container--details-header-right">
                <!-- <font-awesome-icon icon="trash-alt" />&nbsp;Remove Admin -->
              </div>
            </div>
            <p class="edit__container--details-text">Permissions:</p>
            <div class="permissions-list">
              <div
                v-for="(permission, index) in permissions"
                :key="index"
                class="permission-item"
              >
               
                <label :for="'permission_' + index" class="label">{{
                  permission.title
                }}</label>
                 <input
                  type="checkbox"
                  :id="'permission_' + index"
                  v-model="permission.checked"
                  class="checkbox"
                />
              </div>
            </div>

            <div class="edit__container--error">
              <span v-if="networkError">{{ networkError }}</span>
              <span v-if="successMsg">Admin updated successfully.</span>
              <span v-if="individualError"
                >You have not selected a resource.</span
              >
            </div>
            <div class="edit__container--details-btn">
              <div @click="editAdmin" v-if="!loader">Save</div>
              <div v-if="loader">
                <WhiteLoader />
              </div>
              <div
                @click="deleteAdminAccess"
                style="background-color: red"
                v-if="!deleteLoader"
              >
                Remove Admin Previledges
              </div>
              <div style="background-color: red" v-if="deleteLoader">
                <WhiteLoader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import ChangePassword from "./changePassword";
import WhiteLoader from "../../partials/white-loader";
import PageLoader from "../../partials/page-loader";

import * as types from "../../../store/constant";

export default {
  name: "EditAdmin",

  data() {
    return {
      pageLoading: true,
      item: "setting",
      password: false,
      userName: "",
      userID: "",
      networkError: null,
      successMsg: false,
      individualError: false,
      loader: false,
      deleteLoader: false,
      employee: false,
      employeeList: [],
      employeeArray: [],
      resourcesArray: [],
      permissionsArray: [],
      IndividualResourcesArray: [],
      selectedAdmin: null,
      userPermission: [],
      permissions: [],
    };
  },
  components: {
    Header,
    Sidebar,
    ChangePassword,
    WhiteLoader,
    PageLoader,
  },
  methods: {
    changePassword() {
      this.selectedAdmin = this.$route.params.id;
      this.password = true;
    },
    closePassword() {
      this.password = false;
    },
    getEmployees() {
      return this.$http.get(types.GET_EMPLOYEES_API);
    },
    getresources() {
      return this.$http.get(types.GET_RESOURCES_API);
    },
    editAdmin() {
      this.networkError = false;
      this.successMsg = false;
      this.individualError = false;

      let formData = this.IndividualResourcesArray;

      const resources = [];
      for (let index = 0; index < this.resourcesArray.length; index++) {
        for (
          let val = 0;
          val < this.resourcesArray[index].resource_action.length;
          val++
        ) {
          resources.push(this.resourcesArray[index].resource_action[val]);
        }
      }

      if (formData.length === 0) {
        this.individualError = true;
        return;
      }

      const permissionData = [];
      for (let num = 0; num < resources.length; num++) {
        for (let key = 0; key < formData.length; key++) {
          if (formData[key] === resources[num].action) {
            permissionData.push(resources[num].id);
          }
        }
      }

      this.loader = true;

      const addAdminData = {
        user_id: this.userID,
        permissions: permissionData,
      };

      const adminReq = this.$http.post(types.ADMIN_API, {
        employee: this.userID,
      });
      const userReq = this.$http.post(types.USER_PERMISSION_API, addAdminData);

      this.$http
        .all([adminReq, userReq])
        .then(
          this.$http.spread((adm, user) => {
            this.successMsg = true;
            this.loader = false;
          })
        )
        .catch((error) => {
          this.loader = false;
          this.networkError = true;
        });
    },
    getPermissionsList() {
      return this.$http.get(types.PERMISSION_API);
    },
    deleteAdminAccess() {
      this.deleteLoader = true;
      this.networkError = null;

      const user_id = this.$route.params.id;
      this.$http
        .post(`${types.REMOVE_ADMIN_API}`, { user_id })
        .then((resp) => {
          this.deleteLoader = false;
          this.$router.push("/settings");
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.networkError = err.response.data.message;
          }
          this.deleteLoader = false;
        });
    },
    getPermissionsForUser(userId) {
      return this.$http.get(types.USER_PERMISSION_API + "/" + userId);
    },
    getAllPermissionsList() {
      this.$http
        .get(types.GET_ALL_PERMISSIONS_LIST)
        .then((response) => {
          this.permissions = response.data.data; // Assuming response.data contains permissions data
          this.logPermissions();
        })
        .catch((error) => {
          console.error("Error fetching permissions:", error);
        });
    },
    logPermissions() {
      this.$http
        .get(types.GET_USER_PERMISSIONS_LIST)
        .then((response) => {
          console.log("user Permissions loaded:", response);
        })
        .catch((error) => {
          console.error("Error fetching permissions:", error);
        });
    },
  },
  created() {
    this.getAllPermissionsList();
    this.logPermissions();
    this.pageLoading = true;
    if (this.$store.state.allAdmins.length !== 0) {
      for (let index of this.$store.state.allAdmins) {
        if (
          parseInt(this.$route.params.id, 10) === parseInt(index.user.id, 10)
        ) {
          var user = index.user;
        }
      }

      this.userID = user.id;
      this.userName =
        user.firstname.charAt(0).toUpperCase() +
        user.firstname.slice(1) +
        " " +
        (user.middlename ? user.middlename : "") +
        " " +
        user.lastname.charAt(0).toUpperCase() +
        user.lastname.slice(1);

      this.$http
        .all([
          this.getEmployees(),
          this.getPermissionsList(),
          this.getPermissionsForUser(user.id),
        ])
        .then(
          this.$http.spread((employee, permissions, userPermission) => {
            if (employee) {
              this.employee = true;
              this.employeeArray = [...employee.data.data.data];
              this.employeeArray.forEach((value) => {
                this.employeeList.push({
                  id: value.user.id,
                  name:
                    value.user.firstname +
                    " " +
                    value.user.middlename +
                    " " +
                    value.user.lastname,
                });
              });
            }
            if (permissions) {
              this.permissionsArray = [...permissions.data.data];
            }

            if (userPermission) {
              this.userPermission = [...userPermission.data.data];
            }

            this.pageLoading = false;
          })
        );

      return;
    }

    this.$router.push("/settings");
  },
};
</script>

<style lang="scss" scoped>
.permissions-list {
  font-family: Arial, sans-serif;
  font-size: 0.75rem;
  width: 80%;
}

.permission-item {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  padding: 0.5rem;
}

.permission-item:nth-child(even) {
  background-color: #f2f2f2; 
}

.checkbox {
  height: 1rem;
  background: #f17d6b;
  margin-right: 10px;
}

.label {
  display: inline-block;
  text-align: left; 
  margin-bottom: 0;
}

.edit {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;
  padding-bottom: 100px;

  > p {
    font-size: 0.938vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;

    > .edit__back {
      a {
        color: #5099de;
        text-decoration: none;
      }
    }

    > .edit__current {
      color: #707070;
    }
  }

  .edit__container {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding-top: 20px;
    padding-bottom: 80px;
    padding-left: 5.729vw;
    padding-right: 5.729vw;

    > .edit__container--avatar {
      width: 58.2px;
      margin: auto;
    }

    > .edit__container--text {
      font-size: 1.458vw;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
      margin-top: 50px;
    }

    > .edit__container--loader {
      margin-top: 50px;

      > div {
        width: 55px;
        margin: auto;
      }
    }

    .edit__container--details {
      margin-top: 30px;
      padding-top: 50px;
      padding-left: 18.021vw;
      border-top: 1px solid rgba(0, 0, 0, 0.1);

      > .edit__container--details-header {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        text-align: left;

        > .edit__container--details-header-left {
          width: 30%;
          font-size: 1.042vw;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }

        > .edit__container--details-header-middle {
          width: 50%;

          > span {
            font-size: 1.042vw;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            color: #5099de;
          }

          > p {
            font-size: 0.833vw;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.88;
            letter-spacing: 0.48px;
            text-decoration: underline;

            > a {
              color: #777777;
              text-decoration: none;
            }
          }
        }

        > .edit__container--details-header-right {
          width: 20%;
          font-size: 0.938vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: 0.54px;
          text-align: left;
          color: #f17d6b;
          cursor: pointer;
        }
      }

      > .edit__container--details-text {
        font-size: 1.042vw;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: 2;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        text-decoration: underline;
      }

      .edit__container--details-body {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        text-align: left;
        margin-bottom: 20px;

        .edit__container--details-body-left {
          width: 30%;
          font-size: 1.042vw;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }

        .edit__container--details-body-right {
          width: 70%;

          > span {
            font-size: 1.042vw;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }

          > p {
            font-size: 1.042vw;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: left;
            color: #5099de;
            cursor: pointer;
          }

          > div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: flex-start;
            align-content: center;
            padding-bottom: 30px;

            > .edit__container--details-body-right-check {
              width: 20px;
              height: 20px;
              background-color: #ffffff;

              > input {
                width: 20px;
                height: 20px;
                border: 0;
                outline: 0;
                background: #fff;
              }
            }

            > .edit__container--details-body-right-text {
              width: calc(100% - 30px);
              padding-left: 1.563vw;
              background-color: #ffffff;
              font-size: 1.042vw;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.5;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
            }
          }

          > .edit__container--details-body-right-password {
            border: 1px solid red;
          }
        }
      }

      > .edit__container--error {
        height: 50px;
        font-size: 0.938vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: left;
        color: red;
        margin-top: 20px;
        font-style: italic;
      }

      > .edit__container--details-loader {
        width: 9.063vw;
        height: 41px;
        border-radius: 5px;
        background-color: #5099de;
        font-size: 0.781vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }

      > .edit__container--details-btn {
        width: 270px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        > div {
          width: 9.063vw;
          height: 41px;
          border-radius: 5px;
          background-color: #5099de;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>